/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { Accordion as AccordionRoot } from "./Accordion.molecule";
import { AccordionContent } from "./AccordionContent";
import { AccordionHeader } from "./AccordionHeader";
import { AccordionItem } from "./AccordionItem";
import { AccordionTrigger } from "./AccordionTrigger";

import type { AccordionProps } from "./Accordion.molecule";
import type { AccordionContentProps } from "./AccordionContent";
import type { AccordionHeaderProps } from "./AccordionHeader";
import type { AccordionItemProps } from "./AccordionItem";
import type { AccordionTriggerProps } from "./AccordionTrigger";

const Accordion: typeof AccordionRoot & {
	Content: typeof AccordionContent;
	Header: typeof AccordionHeader;
	Item: typeof AccordionItem;
	Trigger: typeof AccordionTrigger;
} = Object.assign(AccordionRoot, {
	Content: AccordionContent,
	Header: AccordionHeader,
	Item: AccordionItem,
	Trigger: AccordionTrigger,
});

export { Accordion, AccordionContent, AccordionItem, AccordionHeader, AccordionTrigger };

export type { AccordionContentProps, AccordionHeaderProps, AccordionItemProps, AccordionProps, AccordionTriggerProps };
